import React, { Component } from "react"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import Select from "react-select"
import GlobalHelper from "../GlobalHelper"

/*  Attentions
 ** This component is deprecated, please use src/common/user/selection/selection.component.tsx instead for new features
 */
class DeprecatedUserSelect extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            options: [],
            selectedOption: this.props.value,
            style: this.props.style || {},
            clearable: !isNaN(this.props.clearable) ? this.props.clearable : true
        }

        const defaultCallback = () => {}
        this.name = this.props.name
        this.multi = this.props.multi || false
        this.disabled = this.props.disabled || false
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.required = this.props.required || false
        this.filter =
            this.props.filter ||
            function() {
                return true
            }
        this.handleChange = this.handleChange.bind(this)
        this.onBlur = this.props.onBlur || defaultCallback
    }

    handleChange(selectedOption) {
        this.setState(
            {
                selectedOption: selectedOption
            },
            () => {
                let val = ""
                let label = ""
                if (this.multi) {
                    val = []
                }
                if (selectedOption) {
                    if (this.multi) {
                        val = selectedOption.map(option => option.value)
                        label = selectedOption.map(option => option.label).join(",")
                    } else {
                        val = selectedOption.value
                        label = selectedOption.label
                    }
                }

                this.onChange(val, label)
            }
        )
    }

    loadUsers() {
        AppContext.getApiClient()
            .get("/users")
            .then(res => {
                this.setState({
                    options: res.data.filter(this.filter).map(user => {
                        return {
                            value: user.id,
                            label: GlobalHelper.GetFormattedName(user)
                        }
                    })
                })
            })
    }

    componentDidMount() {
        this.loadUsers()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            selectedOption: nextProps.value || (this.multi ? [] : "")
        })
    }

    render() {
        return (
            <Select
                disabled={this.disabled}
                multi={this.multi}
                name={this.name}
                placeholder={this.placeholder}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                onBlur={this.onBlur}
                options={this.state.options}
                required={this.required}
                style={this.state.style}
                clearable={this.state.clearable}
            />
        )
    }
}

export default DeprecatedUserSelect



// WEBPACK FOOTER //
// ./src/common/user/selection.component.jsx